module.exports = __webpack_public_path__ + "static/media/viber.8e7bc922.svg";